/**
 * Atualização da aplicação instalada/cacheada.
 *
 * O service worker usa `skipWaiting` + `clientsClaim`, então uma versão nova
 * assume o controle assim que é instalada — mas a página já aberta continua
 * executando o JavaScript antigo que carregou. Sem isto, quem já visitou o site
 * continua vendo a versão anterior até recarregar manualmente.
 *
 * Recarregar é seguro no meio de uma partida: a sessão fica no armazenamento
 * local e o cliente reconecta na mesma sala, com a mesma mão.
 */
export function watchForUpdates(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  // Sem controlador significa primeira visita: o `clientsClaim` inicial não é
  // uma atualização e não deve provocar recarga.
  if (!navigator.serviceWorker.controller) return;

  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}
